import { ReactNode, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

interface IProps {
    children: ReactNode;
}

const AuthLayoutWithReCaptcha = ({ children }: IProps) => {
    useEffect(() => {
        return () => {
            const grepcatchaBadgeElem = document.querySelector(".grecaptcha-badge");
            const grepCatchaBagdgeWrapperElem = grepcatchaBadgeElem?.parentElement;
            if (grepCatchaBagdgeWrapperElem)
                grepCatchaBagdgeWrapperElem.remove();
        }
    }, [])

    return (
        <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}>
            <div
                className={"flex flex-col min-h-screen justify-between items-center text-neutral-100 px-2 bg-neutral-800 md:bg-neutral-800 text-center"}>
                <div className={"flex max-w-7xl px-1 w-full justify-center items-center"}>
                    <Link to={"/"}>
                        <LazyLoadImage
                            alt=""
                            className="object-cover auto min-h-full h-16 md:h-14 my-4"
                            effect="opacity"
                            src={`/images/logofull.png`}
                        />
                    </Link>
                </div>
                {children}
                <span className={"min-h-20"} />
            </div>
        </GoogleReCaptchaProvider>
    );
};

export default AuthLayoutWithReCaptcha;